@for (profile of profiles; track profile) {
  <app-action-item borderColor="#beebbc" titleColor="#000000" backgroundColor="var(--shade-2-color)" color="#000000"
    titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name" (click)="handleClick(profile)" matRipple
    class="action-item" iconCSS="fa-plus">
    <sc-flex vertical stretchContent fitHeight centered>
      <sc-content-spacer vertical grow></sc-content-spacer>
      <sc-icon iconClass="fa-truck fa-6x"></sc-icon>
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="label">{{profile.name}}</div>
      <sc-content-spacer vertical grow></sc-content-spacer>
    </sc-flex>
  </app-action-item>
}
